import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../../models/api-resource.interface';
import { Candidate } from './../../candidates/candidate.interface';

export const CALLLIST_CANDIDATE_INCLUDES = [
   'candidateJourneys',
   'pokes',
   'tenant',
   'statuses',
   'recentPoke',
   'salutation',
   'communicationLanguage',
   'user',
   'addresses',
   'addresses.city',
   'addresses.addressType',
   'phoneNumbers',
   'communicationPreferences',
   'profile',
   'courses',
   'socialSecurityNumbers',
   'workExperiences',
   'jobDistances',
   'resume',
   'profilePicture',
];

export class CandidateService {
   async getCandidates(callListId: number, query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Candidate>>>(`/call-lists/${callListId}/candidates`, { params: { ...query } });
      return response.data;
   }

   async getCandidate() {
      throw Error('Method not implemented');
   }

   async postCandidate() {
      throw Error('Method not implemented');
   }

   async putCandidates(callListId: number, candidates: Array<any>) {
      const response = await http.put<ApiResource<Array<Candidate>>>(`/call-lists/${callListId}/candidates`, candidates);
      return response.data;
   }

   async deleteCandidates(callListId: number, candidates: any) {
      const response = await http.delete(`/call-lists/${callListId}/candidates`, { data: candidates });
      return response;
   }

   async postCandidates(callListId: number, candidates: Array<{ candidate_id: number; is_handled: boolean | number }>) {
      const response = await http.post<ApiResource<Array<Candidate>>>(`/call-lists/${callListId}/candidates`, candidates);
      return response.data;
   }
}
